<div>
  <h2>Auftragsübersicht</h2>
  &nbsp;
</div>

<div>
  <h2>Vorhandene Lieferscheine</h2>

  <table class="table whitetable" style="max-width: 500px;">
    <thead>
      <tr>
        <th>Lieferschein</th>
        <th>Menge</th>
        <th>Datum</th>
        <th>Ersteller</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>

      @for (delivery of deliveries; track delivery.id) {
        <tr>
          <td>
            <ev-file-button [objId]="delivery.id" type="delivery">
              {{ delivery.id }}
            </ev-file-button>
          </td>
          <td>
            <ev-file-button [objId]="delivery.id" type="delivery">
              {{ delivery.quanity }}
            </ev-file-button>
          </td>
          <td>
            <ev-file-button [objId]="delivery.id" type="delivery">
              {{ delivery.date }}
            </ev-file-button>
          </td>
          <td>
            <ev-file-button [objId]="delivery.id" type="delivery">
              {{ delivery.username }}
            </ev-file-button>
          </td>
          <td>
            <button type="button" class="btn btn-link btn-sm" (click)="historyDelivery(delivery)">
              <i class="fa fa-clock-o"></i>
            </button>
          </td>
          <td>
            @if (delivery.delivery_invoice_lock) {
              <div class="label label-danger">
                Gesperrt
              </div>
            }
            @if (delivery.delivery_invoice_lock) {
              <button class="btn btn-link btn-sm" (click)="unlock(delivery)">
                <i class="fa fa-unlock"></i> Entsperren
              </button>
            }
            @if (!delivery.delivery_invoice_lock) {
              <button class="btn btn-link btn-sm" (click)="lock(delivery)">
                <i class="fa lock"></i> Sperren
              </button>
            }
          </td>
          <td>
            @if (('delivery.storno'|HasPerm) &&
              !delivery.delivery_invoice_lock &&
              !delivery.storno &&
              delivery.hasNoInvoice &&
              delivery.containsNoInvoicedFetch) {
              <button class="btn btn-link btn-sm"
                (click)="storno(delivery)">
                <i class="fa lock"></i> Stornieren
              </button>
            }
            @if (delivery.storno) {
              <div class="label label-danger">
                Storniert
              </div>
            }
            @if (data.workflow.object.status === 5 && !delivery.storno) {
              <div class="label label-success">
                Abgerechnet
              </div>
            }
          </td>
        </tr>
      }

    </tbody>
  </table>
</div>

